<td *ngIf="tableMetaWithDataKey.selectionMode !== '' && !readOnly" class="table-data-no-overflow table-col-checkbox">
  <span class="ui-column-title-custom"></span>
  <span class="ui-cell-content">
    <p-tableCheckbox *ngIf="tableMetaWithDataKey.selectionMode === 'multiple'" [value]="item"></p-tableCheckbox>
  </span>
</td>


<td *ngFor="let column of tableMetaWithDataKey.columns; let columnIndex = index"
  [ngClass]="DISPLAY_TEXT_OVERFLOW ? (isRowExpanded(tableData, item) ? 'table-data-expanded' : 'table-data-overflow') : 'table-data-no-overflow'">

  <p-inplace [disabled]="readOnly || (readOnly$ | async)" (onActivate)="editing = true">
    <ng-template pTemplate="display">
      <span class="ui-cell-content">{{ $any(tableItem)[column.name] | displayFormat:column }}</span>
    </ng-template>
    <ng-container *ngIf="inputs else loading">
      <ng-template pTemplate="content">
        <span class="ui-cell-content" *ngIf="inputs[columnIndex].attributeMetadata.name === 'en~jedinica_gradiva~arhivska_oznaka'">{{ $any(tableItem)[column.name] | displayFormat:column }}</span>
        <div class="property-input" *ngIf="!(inputs[columnIndex].attributeMetadata.name === 'en~jedinica_gradiva~arhivska_oznaka')" [ngClass]="'attr-' + inputs[columnIndex].attributeMetadata.name">
          <ntap-dynamic [compId]="inputs[columnIndex].componentId" [inputParam]="inputs[columnIndex]"></ntap-dynamic>
        </div>
        <!-- (focusout)="onRowEditSave(tableMetaWithDataKey, item, rowIndex)" -->
      </ng-template>
    </ng-container>
    <ng-template #loading>
      <ng-template pTemplate="content">
        <p-progressSpinner></p-progressSpinner>
      </ng-template>
    </ng-template>
  </p-inplace>
</td>

<td class="table-col-actions-spremi"
  [ngStyle]="{'position': 'sticky', 'right': '0', 'background': 'white', 'z-index': '1'}"
  *ngIf="!readOnly">
  <span class="ui-cell-content">
      <div class="flex align-items-center justify-content-center gap-2">
        <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-save"
          (click)="onRowEditSave(tableMetaWithDataKey, item, rowIndex)" [disabled]="formInvalid"
          class="p-element p-ripple p-button-rounded p-button-warning p-button p-component p-button-icon-only mr-2"></button>

      </div>
  </span>
</td>

<td class="table-col-actions">
  <span class="ui-cell-content">
    <ng-container *ngIf="!readOnly">
      <ntap-dynamic [compId]="DEFAULT_ACTION_BAR_COMP_ID" *ngIf="tableMetaWithDataKey.hasActions"></ntap-dynamic>
    </ng-container>
  </span>
</td>